import type { AssignmentFormData } from '../../../types/assignmentTypes';
import AutomationsFormPreview from '../AutomationsFormPreview';
import { useFormContext } from 'react-hook-form';

export default function AutomationsFormPreviewWrapper() {
  const { watch } = useFormContext<AssignmentFormData>();

  const { settings: watchedSettings } = watch() as {
    settings: AssignmentFormData['settings'];
  };

  return <AutomationsFormPreview settings={watchedSettings} renderStatus />;
}
